import React from "react";
import AdminLayout from "./AdminLayout";
import AdminNotificationManagement from "../../components/Admin/AdminNotificationManagement";

const NotificationsPage = () => {
  return (
    <AdminLayout>
      <AdminNotificationManagement />
    </AdminLayout>
  );
};

export default NotificationsPage;
